import axios from 'axios';
import { useEffect, useState } from 'react';
import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';
import { useParams, useHistory } from 'react-router-dom';
import { handleAxiosError } from 'core/notifications';

export default () => {
  const queryClient = useQueryClient();

  const [view, setView] = useState(localStorage.getItem('videosTopicView') || 'tile');

  const { id } = useParams();

  const queryKey = ['topic', id];

  const history = useHistory();

  const updateTopicStatusUrl = `/api/learner/videos/topics/${id}/follows`;

  const fetchTopic = async () => {
    try {
      const { data } = await axios.get(`/api/learner/videos/topics/${id}`);
      return data;
    } catch (error) {
      if (error.response?.status === 403) {
        history.push('/student/videos/unauthorized');
        return null;
      }
    }
  };

  const followTopic = async () => {
    try {
      const { data } = await axios.post(updateTopicStatusUrl);
      return data;
    } catch (error) {
      handleAxiosError(error);
    }
  };

  const unfollowTopic = async () => {
    try {
      const { data } = await axios.delete(updateTopicStatusUrl);
      return data;
    } catch (error) {
      handleAxiosError(error);
    }
  };

  const { data, isLoading } = useQuery(queryKey, fetchTopic);

  useEffect(() => {
    localStorage.setItem('videosTopicView', view);
  }, [view]);

  const handleViewChange = (layoutView) => {
    setView(layoutView);
  };

  const useFollowTopicMutation = (isFollowedValue) =>
    useMutation({
      mutationFn: isFollowedValue ? followTopic : unfollowTopic,
      onMutate: async () => {
        await queryClient.cancelQueries({ queryKey });

        const previousData = queryClient.getQueryData(queryKey);

        queryClient.setQueryData(queryKey, (oldData) => ({
          ...oldData,
          data: {
            ...oldData.data,
            is_followed: isFollowedValue,
          },
        }));

        return { previousData };
      },
    });

  const followTopicMutation = useFollowTopicMutation(true);
  const unfollowTopicMutation = useFollowTopicMutation(false);

  return {
    view,
    data,
    isLoading,
    handlers: {
      handleViewChange,
      followTopic: followTopicMutation,
      unfollowTopic: unfollowTopicMutation,
    },
  };
};
